// Tabs
const tabs = () => {
  const tabButtons = document.querySelectorAll('.tab');
  const tabPanels = document.querySelectorAll('.tab-panel');
  const collapseButtons = document.querySelectorAll('.collapse-panel-toggle');
  // const collapsePanels = document.querySelectorAll('.collapse-panel');

  [].map.call(tabButtons, tab => tab.addEventListener('click', (event) => {
    [].map.call(tabButtons, (tabButton) => {
      tabButton.parentElement.classList.remove('active');
      tabButton.setAttribute('aria-expanded', 'false');
    });
    [].map.call(tabPanels, panel => panel.classList.remove('active'));
    event.currentTarget.parentElement.classList.add('active');
    event.currentTarget.setAttribute('aria-expanded', 'true');
    document.getElementById(event.currentTarget.getAttribute('data-panel')).classList.add('active');
  }));

  [].map.call(collapseButtons, collapse => collapse.addEventListener('click', (event) => {
    if (event.currentTarget.firstElementChild.classList.contains('minus')) {
      event.currentTarget.firstElementChild.classList.remove('minus');
      document.getElementById(event.currentTarget.getAttribute('data-collapse')).classList.remove('active');
    } else {
      // [].map.call(collapseButtons, collapseButton => collapseButton.firstElementChild.classList.remove('minus'));
      // [].map.call(collapsePanels, collapsePanel => collapsePanel.classList.remove('active'));
      event.currentTarget.firstElementChild.classList.add('minus');
      document.getElementById(event.currentTarget.getAttribute('data-collapse')).classList.add('active');
    }
  }));
};

export default tabs;
